module.exports = __webpack_public_path__ + "MaterialIcons-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.eot
// module id = 80
// module chunks = 0